import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Pagination } from "swiper/modules";

const JenisSekolah = () => {
  const [sekolahList, setSekolahList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Base URL untuk API dan gambar
  const API_BASE_URL = 'https://app.bimbelstemakupang.com/api';
  const STORAGE_BASE_URL = 'https://app.bimbelstemakupang.com/storage';

  // Fetch data dari API
  useEffect(() => {
    const fetchSekolahData = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE_URL}/sekolah-kedinasan`);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const result = await response.json();
        
        if (result.success) {
          // Transform data untuk menyesuaikan dengan format yang dibutuhkan komponen
          const transformedData = result.data.map(item => ({
            id: item.id,
            img: item.image ? `${STORAGE_BASE_URL}/${item.image}` : '/assets/img/person/default.png',
            name: item.name,
            desc: item.name, // Atau bisa pakai singkatan jika ada
            text: item.description
          }));
          
          setSekolahList(transformedData);
        } else {
          throw new Error(result.message || 'Failed to fetch data');
        }
      } catch (err) {
        console.error('Error fetching sekolah data:', err);
        setError(err.message);
        
        // Fallback ke data static jika API gagal
        setSekolahList([
          {
            img: "/assets/img/person/ipdn.PNG",
            name: "IPDN",
            desc: "Institut Pemerintahan Dalam Negeri",
            text: "Institut yang mencetak calon pemimpin di bidang pemerintahan dalam negeri."
          },
          // ... data static lainnya sebagai fallback
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchSekolahData();
  }, []);

  // Loading state
  if (loading) {
    return (
      <section id="team" className="team section">
        <div className="container section-title">
          <h2>BERBAGAI MACAM</h2>
          <div>
            <span>SEKOLAH</span>{" "}
            <span className="description-title">KEDINASAN</span>
          </div>
        </div>
        <div className="container">
          <div className="text-center">
            <p>Memuat data sekolah kedinasan...</p>
          </div>
        </div>
      </section>
    );
  }

  // Error state
  if (error && sekolahList.length === 0) {
    return (
      <section id="team" className="team section">
        <div className="container section-title">
          <h2>BERBAGAI MACAM</h2>
          <div>
            <span>SEKOLAH</span>{" "}
            <span className="description-title">KEDINASAN</span>
          </div>
        </div>
        <div className="container">
          <div className="text-center">
            <p>Error: {error}</p>
            <button onClick={() => window.location.reload()}>Coba Lagi</button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="team" className="team section">
      <div className="container section-title">
        <h2>BERBAGAI MACAM</h2>
        <div>
          <span>SEKOLAH</span>{" "}
          <span className="description-title">KEDINASAN</span>
        </div>
      </div>
      <div className="container">
        {sekolahList.length > 0 ? (
          <Swiper
            modules={[Navigation, Pagination]}
            spaceBetween={30}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true }}
            breakpoints={{
              576: { slidesPerView: 2 },
              992: { slidesPerView: 3 },
              1200: { slidesPerView: 4 }
            }}
          >
            {sekolahList.map((item, i) => (
              <SwiperSlide key={item.id || i}>
                <div className="team-card">
                  <div className="team-image">
                    <img
                      src={item.img}
                      className="img-fluid"
                      alt={item.name}
                      loading="lazy"
                      onError={(e) => {
                        e.target.src = '/assets/img/person/default.png';
                      }}
                    />
                  </div>
                  <div className="team-content">
                    <h3>{item.name}</h3>
                    <span>{item.desc}</span>
                    <p>{item.text}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <div className="text-center">
            <p>Tidak ada data sekolah kedinasan yang tersedia.</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default JenisSekolah;